(function () {
  document.addEventListener('DOMContentLoaded', function () {

    // Warn on leave: customize BS modal
    warnOnLeave = function () {

      let modalLinks = document.querySelectorAll('[data-bs-target="#modalWOL"]');
      let wol = document.getElementById("modalWOL");
      const externalLinkAnchor = document.getElementById('externalLink');

      if (externalLinkAnchor) {
        externalLinkAnchor.addEventListener('click', function () {
          const modalInstance = bootstrap.Modal.getInstance(wol);
            if (modalInstance) {
                modalInstance.hide();
            }
        });
      } else {
        return;
      }

      if (!wol) {
        return;
      }

      modalLinks.forEach(modalLink => {
        const href = modalLink.getAttribute('href');
        modalLink.addEventListener('click', e => {
          e.preventDefault();
          if (externalLinkAnchor) {
            externalLinkAnchor.setAttribute('href', href);
          }
        });
      });

    }();

  });
})();
